import { render } from "./ServicesPage.vue?vue&type=template&id=2ec2914b&scoped=true&ts=true"
import script from "./ServicesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServicesPage.vue?vue&type=script&lang=ts&setup=true"

import "./ServicesPage.vue?vue&type=style&index=0&id=2ec2914b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec2914b"],['__file',"src/pages/settings/pages/services/ServicesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ec2914b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ec2914b', __exports__)) {
    api.reload('2ec2914b', __exports__)
  }
  
  module.hot.accept("./ServicesPage.vue?vue&type=template&id=2ec2914b&scoped=true&ts=true", () => {
    api.rerender('2ec2914b', render)
  })

}


export default __exports__